import { apiConstants } from '../../apiConstant'
import { formDataCommonFunction, formDataCommonFunctionPut, formDataCommonFunctionPutWithoutAuth, serviceCall } from '../../serviceCall'

const acceptCompanyJoinRequestApi = (data, callback, errorCallBack,params) => {
  
  return async (dispatch) => {
 
    formDataCommonFunctionPut(data,apiConstants.COMPANIES.ACCEPT_COMPANY_JOIN_REQUEST)
      .then((response) => {
        callback && callback(response)
      })
      .catch((error) => {
        errorCallBack && errorCallBack(error.response)
      })
  }
}

export default acceptCompanyJoinRequestApi;